import { SatelliteConversationFolderTypeV2 } from '@zg-rentals/ts-satellite-client';
import { getValueFromEnum } from './getValueFromEnum';

// TODO: Shared with SLW in satellite-components
export default (folder: string | null): SatelliteConversationFolderTypeV2 => {
  if (folder === 'REPORTED') {
    return SatelliteConversationFolderTypeV2.SPAM;
  } else {
    return getValueFromEnum(folder, SatelliteConversationFolderTypeV2) || SatelliteConversationFolderTypeV2.INBOX;
  }
};
